export default __webpack_public_path__ + "static/media/drop-ended.4da770f0.png";